import SERVICES from 'app-constants/service.names';
import { CollectionService } from './base.service';

class Service extends CollectionService {
  constructor() {
    super(SERVICES.PARTNER);
  }
}

export default new Service();
